/* eslint-disable no-extend-native*/

export default Array.prototype.isNullOrEmpty = function() {
  if (!this) return true;
  if (this.length === 0) return true;
  return false;
};
